/* Copyright (c) 2022-2025 Nordcloud Oy or its affiliates. All Rights Reserved. */

import {
  useCreateCloudResourceReportMutation,
  CreateCloudResourceReportInput,
} from "~/generated/graphql";
import { showSuccess, showError } from "~/services/toast";

export function useCreateCloudResourceReport() {
  const [createCloudResourceReportMutation, { loading }] =
    useCreateCloudResourceReportMutation({
      onCompleted: (response) => {
        if (response?.createCloudResourceReport) {
          showSuccess(
            "Your CSV report is being generated. You can track the progress in the 'Reports' section of the 'Resources' tab.",
            { type: "info" }
          );
        } else {
          showError("There was an issue with generating the report.");
        }
      },
      onError: (error) => {
        showError(`Failed to generate the report: ${error.message}`);
      },
    });

  function createCloudResourceReport(data: CreateCloudResourceReportInput) {
    createCloudResourceReportMutation({
      variables: {
        input: data,
      },
    });
  }

  return [createCloudResourceReport, loading] as const;
}
